import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import {
  SchoolMobileSettings,
  SchoolMobileSettingsRequest,
} from '../entities/school-mobile-settings.model';

/**
 * `/SchoolMobileSettings` (SchoolService) — Ediz app display settings for the
 * authenticated tenant. `GET` never 404s (the record is created with the
 * defaults on first read); `PUT` takes the whole record and echoes it back, so
 * no refetch after saving.
 *
 * Refusals (422, text over the cap) use the standard envelope whose `Message`
 * is already localized — surfaced verbatim, never re-mapped.
 */
@Injectable({ providedIn: 'root' })
export class SchoolMobileSettingsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.school_service;

  public get(): Observable<SchoolMobileSettings> {
    return this.http.get<SchoolMobileSettings>(`${this.baseUrl}/SchoolMobileSettings`, {
      withCredentials: true,
    });
  }

  public update(body: SchoolMobileSettingsRequest): Observable<SchoolMobileSettings> {
    return this.http.put<SchoolMobileSettings>(`${this.baseUrl}/SchoolMobileSettings`, body, {
      withCredentials: true,
    });
  }
}
